var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "center-active": "",
            "show-arrows": "",
            height: "36",
            dense: "",
          },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "General" }, [_vm._v("General")]),
          _vm._l(_vm.calculations, function (calculation) {
            return [
              _vm.computedSettings[calculation.key].active
                ? _c("v-tab", { key: "" + calculation.key }, [
                    _vm._v(_vm._s(calculation.name)),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { key: "General" },
            [
              _c(
                "v-card",
                { staticClass: "d-flex justify-center", attrs: { flat: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-2 ma-2",
                      attrs: { outlined: "", width: "700" },
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-6", attrs: { flat: "" } },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium",
                                },
                                [_vm._v("Model Timeline")]
                              ),
                              _c(
                                "v-row",
                                { staticClass: "align-baseline" },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.schema.year_start.title,
                                          hint: _vm.schema.year_start.tooltip,
                                          "error-messages":
                                            _vm.$utils.getIfExists(_vm.errors, [
                                              "settings",
                                              "year_start",
                                              "messages",
                                            ]),
                                          type: "number",
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.computedSettings.year_start,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings,
                                              "year_start",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "computedSettings.year_start",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.schema.year_end.title,
                                          hint: _vm.schema.year_end.tooltip,
                                          "error-messages":
                                            _vm.$utils.getIfExists(_vm.errors, [
                                              "settings",
                                              "year_end",
                                              "messages",
                                            ]),
                                          type: "number",
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: _vm.computedSettings.year_end,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings,
                                              "year_end",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "computedSettings.year_end",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-col", [
                                    _c(
                                      "p",
                                      { staticClass: "mb-0 text-subtitle-2" },
                                      [
                                        _vm._v(
                                          "Total Years: " +
                                            _vm._s(_vm.num_years)
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-list",
                                { attrs: { flat: "" } },
                                [
                                  _c("v-subheader", [_vm._v("Calculations")]),
                                  _vm._l(
                                    _vm.calculations,
                                    function (calculation) {
                                      return _c("v-list-item", {
                                        key: calculation.key,
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c("v-switch", {
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .computedSettings[
                                                              calculation.key
                                                            ].active,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .computedSettings[
                                                                calculation.key
                                                              ],
                                                              "active",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "computedSettings[calculation.key].active",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            calculation.name
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.computedSettings.ALTERNATIVE_ANALYSIS.active
            ? _c(
                "v-tab-item",
                { key: "Alternative Analysis" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: "Enable MIP",
                                  hint: "Binary Variables",
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "integer",
                                      "messages",
                                    ]
                                  ),
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .integer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "integer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.integer",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.schema.ALTERNATIVE_ANALYSIS.properties
                                      .output_formulation.title,
                                  hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                    .properties.output_formulation.tooltip,
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ALTERNATIVE_ANALYSIS",
                                      "output_formulation",
                                      "messages",
                                    ]
                                  ),
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .output_formulation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "output_formulation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.output_formulation",
                                },
                              }),
                              _c("v-slider", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Tolerance: 1e" +
                                    _vm.settings.ALTERNATIVE_ANALYSIS.tolerance,
                                  hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                    .properties.tolerance.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ALTERNATIVE_ANALYSIS",
                                      "tolerance",
                                      "messages",
                                    ]
                                  ),
                                  max: "-1",
                                  min: "-38",
                                  "always-dirty": "",
                                  "thumb-label": "always",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .tolerance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "tolerance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.tolerance",
                                },
                              }),
                              _c("InputTextField", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.schema.ALTERNATIVE_ANALYSIS.properties
                                      .timeout.title,
                                  hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                    .properties.timeout.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ALTERNATIVE_ANALYSIS",
                                      "timeout",
                                      "messages",
                                    ]
                                  ),
                                  suffix: "seconds",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .timeout,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "timeout",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.timeout",
                                },
                              }),
                              _c(
                                "InputGeneric",
                                {
                                  attrs: {
                                    label:
                                      _vm.schema.ALTERNATIVE_ANALYSIS.properties
                                        .representative_days.title,
                                    hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                      .properties.representative_days.tooltip,
                                  },
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      "persistent-hint": "",
                                      "error-messages": _vm.$utils.getIfExists(
                                        _vm.errors,
                                        [
                                          "settings",
                                          "ALTERNATIVE_ANALYSIS",
                                          "representative_days",
                                          "messages",
                                        ]
                                      ),
                                      items: [
                                        "Clustering",
                                        "Renewable Variability",
                                        "User Defined",
                                      ],
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .ALTERNATIVE_ANALYSIS
                                          .representative_days,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .ALTERNATIVE_ANALYSIS,
                                          "representative_days",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.ALTERNATIVE_ANALYSIS.representative_days",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.settings.ALTERNATIVE_ANALYSIS
                                .representative_days === "User Defined"
                                ? _c("InputDateArray", {
                                    class: "my-" + _vm.inputMargin,
                                    attrs: {
                                      year: _vm.settings.year_start,
                                      "error-messages": _vm.$utils.getIfExists(
                                        _vm.errors,
                                        [
                                          "settings",
                                          "ALTERNATIVE_ANALYSIS",
                                          "chosen_days",
                                          "messages",
                                        ]
                                      ),
                                      ordinal: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .ALTERNATIVE_ANALYSIS.chosen_days,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .ALTERNATIVE_ANALYSIS,
                                          "chosen_days",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.ALTERNATIVE_ANALYSIS.chosen_days",
                                    },
                                  })
                                : _vm._e(),
                              _vm.settings.ALTERNATIVE_ANALYSIS
                                .representative_days !== "User Defined"
                                ? _c("v-slider", {
                                    class: "my-" + _vm.inputMargin,
                                    attrs: {
                                      "error-messages": _vm.$utils.getIfExists(
                                        _vm.errors,
                                        [
                                          "settings",
                                          "ALTERNATIVE_ANALYSIS",
                                          "cluster_days",
                                          "messages",
                                        ]
                                      ),
                                      label:
                                        _vm.schema.ALTERNATIVE_ANALYSIS
                                          .properties.cluster_days.title,
                                      hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                        .properties.cluster_days.tooltip,
                                      min: "1",
                                      max: "30",
                                      "thumb-label": "always",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .ALTERNATIVE_ANALYSIS.cluster_days,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .ALTERNATIVE_ANALYSIS,
                                          "cluster_days",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedSettings.ALTERNATIVE_ANALYSIS.cluster_days",
                                    },
                                  })
                                : _vm._e(),
                              _c("v-slider", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Each simulation year should account for " +
                                    _vm.settings.ALTERNATIVE_ANALYSIS
                                      .simulation_years_each +
                                    " years",
                                  hint: _vm.schema.ALTERNATIVE_ANALYSIS
                                    .properties.simulation_years_each.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ALTERNATIVE_ANALYSIS",
                                      "simulation_years_each",
                                      "messages",
                                    ]
                                  ),
                                  min: "1",
                                  max: "20",
                                  "always-dirty": "",
                                  "thumb-label": "always",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .simulation_years_each,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "simulation_years_each",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.simulation_years_each",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ALTERNATIVE_ANALYSIS",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ALTERNATIVE_ANALYSIS
                                      .saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ALTERNATIVE_ANALYSIS,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ALTERNATIVE_ANALYSIS.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.PRODUCTION_COST.active
            ? _c(
                "v-tab-item",
                { key: "Production Cost" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: "Enable MIP",
                                  hint: "Binary Variables",
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "integer",
                                      "messages",
                                    ]
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .integer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "integer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.integer",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.schema.PRODUCTION_COST.properties
                                      .output_formulation.title,
                                  hint: _vm.schema.PRODUCTION_COST.properties
                                    .output_formulation.tooltip,
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "output_formulation",
                                      "messages",
                                    ]
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .output_formulation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "output_formulation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.output_formulation",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: _vm.settings.PRODUCTION_COST.subhourly
                                    ? "Calculate Subhourly"
                                    : "Calculate Hourly",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "subhourly",
                                      "messages",
                                    ]
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .subhourly,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "subhourly",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.subhourly",
                                },
                              }),
                              _c("v-slider", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Tolerance: 1e" +
                                    _vm.settings.PRODUCTION_COST.tolerance,
                                  hint: _vm.schema.PRODUCTION_COST.properties
                                    .tolerance.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "tolerance",
                                      "messages",
                                    ]
                                  ),
                                  max: "-1",
                                  min: "-38",
                                  "always-dirty": "",
                                  "thumb-label": "always",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .tolerance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "tolerance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.tolerance",
                                },
                              }),
                              _c("InputTextField", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.schema.PRODUCTION_COST.properties
                                      .timeout.title,
                                  hint: _vm.schema.PRODUCTION_COST.properties
                                    .timeout.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "timeout",
                                      "messages",
                                    ]
                                  ),
                                  suffix: "seconds",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .timeout,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "timeout",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.timeout",
                                },
                              }),
                              _c("v-select", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.schema.PRODUCTION_COST.properties
                                      .capacity_source.title,
                                  hint: _vm.schema.PRODUCTION_COST.properties
                                    .capacity_source.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "capacity_source",
                                      "messages",
                                    ]
                                  ),
                                  items: ["AA", "Inputs"],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .capacity_source,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "capacity_source",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.capacity_source",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "PRODUCTION_COST",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.PRODUCTION_COST
                                      .saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.PRODUCTION_COST,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.PRODUCTION_COST.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.NODAL_PRODUCTION_COST.active
            ? _c(
                "v-tab-item",
                { key: "Nodal Production Cost" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [_vm._v("Calculation Timeline")]
                                  ),
                                  _c("p", { staticClass: "text-caption" }, [
                                    _vm._v(
                                      "Configure timeline to run the optimization"
                                    ),
                                  ]),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "align-stretch",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "v-btn-toggle",
                                            {
                                              attrs: {
                                                color: "primary",
                                                exclusive: "",
                                                mandatory: "",
                                              },
                                              model: {
                                                value: _vm.npcTimelineOption,
                                                callback: function ($$v) {
                                                  _vm.npcTimelineOption = $$v
                                                },
                                                expression: "npcTimelineOption",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function (ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "size-36",
                                                                  attrs: {
                                                                    icon: "",
                                                                    value:
                                                                      "dates",
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-calendar"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2077720930
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Choose a start and end date"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function (ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "size-36",
                                                                  attrs: {
                                                                    icon: "",
                                                                    value:
                                                                      "years",
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-calendar-multiselect"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1812992469
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Pick specific years"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.npcTimelineOption === "dates"
                                        ? [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "pt-2",
                                                attrs: { sm: "5" },
                                              },
                                              [
                                                _c("InputDateTime", {
                                                  attrs: {
                                                    label: "Start Date",
                                                    timezone: "UTC",
                                                    minDate:
                                                      _vm.systemDateConstraints
                                                        .min,
                                                    maxDate:
                                                      _vm.systemDateConstraints
                                                        .max,
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.computedSettings
                                                        .NODAL_PRODUCTION_COST
                                                        .timelineSettings
                                                        .startDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.computedSettings
                                                          .NODAL_PRODUCTION_COST
                                                          .timelineSettings,
                                                        "startDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "computedSettings.NODAL_PRODUCTION_COST.timelineSettings.startDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "pt-2",
                                                attrs: { sm: "5" },
                                              },
                                              [
                                                _c("InputDateTime", {
                                                  attrs: {
                                                    label: "End Date",
                                                    timezone: "UTC",
                                                    maxDate:
                                                      _vm.systemDateConstraints
                                                        .max,
                                                    minDate:
                                                      _vm.computedSettings
                                                        .NODAL_PRODUCTION_COST
                                                        .timelineSettings
                                                        .startDate,
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.computedSettings
                                                        .NODAL_PRODUCTION_COST
                                                        .timelineSettings
                                                        .endDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.computedSettings
                                                          .NODAL_PRODUCTION_COST
                                                          .timelineSettings,
                                                        "endDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "computedSettings.NODAL_PRODUCTION_COST.timelineSettings.endDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.npcTimelineOption === "years"
                                        ? [
                                            _c(
                                              "v-col",
                                              { staticClass: "pt-2 ml-2" },
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    label: "Years",
                                                    items: _vm.yearItems,
                                                    dense: "",
                                                    multiple: "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.computedSettings
                                                        .NODAL_PRODUCTION_COST
                                                        .timelineSettings.years,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.computedSettings
                                                          .NODAL_PRODUCTION_COST
                                                          .timelineSettings,
                                                        "years",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "computedSettings.NODAL_PRODUCTION_COST.timelineSettings.years",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _c("v-divider"),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [_vm._v("Inputs")]
                                  ),
                                  _c(
                                    "InputGeneric",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm.schema.NODAL_PRODUCTION_COST
                                            .properties.capacity_source.title,
                                        hint: _vm.schema.NODAL_PRODUCTION_COST
                                          .properties.capacity_source.tooltip,
                                      },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items:
                                            _vm.schema.NODAL_PRODUCTION_COST
                                              .properties.capacity_source.enum,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.computedSettings
                                              .NODAL_PRODUCTION_COST
                                              .capacity_source,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings
                                                .NODAL_PRODUCTION_COST,
                                              "capacity_source",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "computedSettings.NODAL_PRODUCTION_COST.capacity_source",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [_vm._v("Outputs")]
                                  ),
                                  _c("v-switch", {
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "Save timeseries outputs",
                                      hint: "This has an impact on running time and output file size",
                                      "persistent-hint": "",
                                      dense: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST
                                          .save_time_series_outputs,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "save_time_series_outputs",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.save_time_series_outputs",
                                    },
                                  }),
                                  _c("v-divider"),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [_vm._v("Solver Settings")]
                                  ),
                                  _c("v-switch", {
                                    attrs: {
                                      label: "Infeasibility Analysis",
                                      hint: "Try to detect the constraints causing infeasibilities. May change results slightly",
                                      "persistent-hint": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST
                                          .infeasibility_analysis,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "infeasibility_analysis",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.infeasibility_analysis",
                                    },
                                  }),
                                  _c("v-switch", {
                                    attrs: {
                                      label: "Enable MIP",
                                      hint: "Binary Variables. More accurate but slower",
                                      "persistent-hint": "",
                                      dense: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST.integer,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "integer",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.integer",
                                    },
                                  }),
                                  _c("v-switch", {
                                    class: "my-" + _vm.inputMargin,
                                    attrs: {
                                      label: !_vm.settings.NODAL_PRODUCTION_COST
                                        .subhourly
                                        ? "Calculate Subhourly"
                                        : "Calculate Hourly",
                                      "error-messages": _vm.$utils.getIfExists(
                                        _vm.errors,
                                        [
                                          "settings",
                                          "NODAL_PRODUCTION_COST",
                                          "subhourly",
                                          "messages",
                                        ]
                                      ),
                                      dense: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST.subhourly,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "subhourly",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.subhourly",
                                    },
                                  }),
                                  _c("v-slider", {
                                    class: "my-" + _vm.inputMargin,
                                    attrs: {
                                      label:
                                        "Tolerance: 1e" +
                                        _vm.settings.NODAL_PRODUCTION_COST
                                          .tolerance,
                                      max: "-1",
                                      min: "-38",
                                      "always-dirty": "",
                                      "thumb-label": "always",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST.tolerance,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "tolerance",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.tolerance",
                                    },
                                  }),
                                  _c("InputTextField", {
                                    attrs: {
                                      label:
                                        _vm.schema.NODAL_PRODUCTION_COST
                                          .properties.timeout.title,
                                      hint: _vm.schema.NODAL_PRODUCTION_COST
                                        .properties.timeout.tooltip,
                                      "error-messages": _vm.$utils.getIfExists(
                                        _vm.errors,
                                        [
                                          "settings",
                                          "NODAL_PRODUCTION_COST",
                                          "timeout",
                                          "messages",
                                        ]
                                      ),
                                      suffix: "seconds",
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings
                                          .NODAL_PRODUCTION_COST.timeout,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .NODAL_PRODUCTION_COST,
                                          "timeout",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedSettings.NODAL_PRODUCTION_COST.timeout",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.STACKED_SERVICES_EMULATOR.active
            ? _c(
                "v-tab-item",
                { key: "Stacked Services Emulator" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium mb-1",
                                },
                                [_vm._v("Calculation Timeline")]
                              ),
                              _c("p", { staticClass: "text-caption" }, [
                                _vm._v(
                                  "Configure timeline to run the optimization"
                                ),
                              ]),
                              _c(
                                "v-row",
                                {
                                  staticClass: "align-stretch",
                                  attrs: { dense: "" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "v-btn-toggle",
                                        {
                                          attrs: {
                                            color: "primary",
                                            exclusive: "",
                                            mandatory: "",
                                          },
                                          model: {
                                            value: _vm.sseTimelineOption,
                                            callback: function ($$v) {
                                              _vm.sseTimelineOption = $$v
                                            },
                                            expression: "sseTimelineOption",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "size-36",
                                                              attrs: {
                                                                icon: "",
                                                                value: "dates",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-calendar"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2077720930
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Choose a start and end date"
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "size-36",
                                                              attrs: {
                                                                icon: "",
                                                                value: "years",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-calendar-multiselect"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1812992469
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Pick specific years"),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.sseTimelineOption === "dates"
                                    ? [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pt-2",
                                            attrs: { sm: "5" },
                                          },
                                          [
                                            _c("InputDateTime", {
                                              attrs: {
                                                label: "Start Date",
                                                timezone: "UTC",
                                                minDate:
                                                  _vm.systemDateConstraints.min,
                                                maxDate:
                                                  _vm.systemDateConstraints.max,
                                                dense: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedSettings
                                                    .timeline_settings
                                                    .start_date,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedSettings
                                                      .timeline_settings,
                                                    "start_date",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedSettings.timeline_settings.start_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pt-2",
                                            attrs: { sm: "5" },
                                          },
                                          [
                                            _c("InputDateTime", {
                                              attrs: {
                                                label: "End Date",
                                                timezone: "UTC",
                                                maxDate:
                                                  _vm.systemDateConstraints.max,
                                                minDate:
                                                  _vm.computedSettings
                                                    .timeline_settings
                                                    .start_date,
                                                dense: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedSettings
                                                    .timeline_settings.end_date,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedSettings
                                                      .timeline_settings,
                                                    "end_date",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedSettings.timeline_settings.end_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.sseTimelineOption === "years"
                                    ? [
                                        _c(
                                          "v-col",
                                          { staticClass: "pt-2 ml-2" },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                label: "Years",
                                                items: _vm.yearItems,
                                                dense: "",
                                                multiple: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.computedSettings
                                                    .timeline_settings.years,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.computedSettings
                                                      .timeline_settings,
                                                    "years",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "computedSettings.timeline_settings.years",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c("v-divider"),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium",
                                    },
                                    [_vm._v("Optimization Settings")]
                                  ),
                                ]
                              ),
                              _c("v-switch", {
                                attrs: {
                                  label: "Infeasibility Analysis",
                                  hint: "Try to detect the constraints causing infeasibilities. May change results slightly",
                                  "persistent-hint": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR
                                      .infeasibility_analysis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "infeasibility_analysis",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.infeasibility_analysis",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.timeline_settings.properties
                                      .time_interval.title,
                                  hint: "The duration between successive energy dispatch calculations",
                                  suffix:
                                    _vm.schema.timeline_settings.properties
                                      .time_interval.unit,
                                  type: "number",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.timeline_settings
                                      .time_interval,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.timeline_settings,
                                      "time_interval",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.timeline_settings.time_interval",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.timeline_settings.properties
                                      .lookahead.title,
                                  hint: "The future time window considered in optimization to anticipate system conditions and plan dispatch decisions.",
                                  suffix:
                                    _vm.schema.timeline_settings.properties
                                      .lookahead.unit,
                                  type: "number",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.timeline_settings
                                      .opt_window_lookahead,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.timeline_settings,
                                      "opt_window_lookahead",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.timeline_settings.opt_window_lookahead",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: "Optimization Window",
                                  hint: "The total time horizon over which the optimization is performed during each simulation step",
                                  suffix:
                                    _vm.schema.timeline_settings.properties
                                      .opt_window.unit,
                                  type: "number",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.timeline_settings
                                      .opt_window,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.timeline_settings,
                                      "opt_window",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.timeline_settings.opt_window",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.timeline_settings.properties
                                      .padding.title,
                                  hint: _vm.schema.timeline_settings.properties
                                    .padding.tooltip,
                                  type: "number",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.timeline_settings
                                      .padding,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.timeline_settings,
                                      "padding",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.timeline_settings.padding",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: "Enable MIP",
                                  hint: "Binary Variables",
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "integer",
                                      "messages",
                                    ]
                                  ),
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.integer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "integer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.integer",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: _vm.sseSchema.output_formulation.title,
                                  hint: _vm.sseSchema.output_formulation
                                    .tooltip,
                                  "persistent-hint": "",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "output_formulation",
                                      "messages",
                                    ]
                                  ),
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR
                                      .output_formulation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "output_formulation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.output_formulation",
                                },
                              }),
                              _c("v-slider", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Tolerance: 1e" +
                                    _vm.settings.STACKED_SERVICES_EMULATOR
                                      .solver_settings.tolerance,
                                  hint: _vm.sseSchema.solver_settings.properties
                                    .tolerance.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "tolerance",
                                      "messages",
                                    ]
                                  ),
                                  max: "-1",
                                  min: "-38",
                                  "always-dirty": "",
                                  "thumb-label": "always",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.solver_settings
                                      .tolerance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR
                                        .solver_settings,
                                      "tolerance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "\n                computedSettings.STACKED_SERVICES_EMULATOR.solver_settings.tolerance\n              ",
                                },
                              }),
                              _c("InputTextField", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    _vm.sseSchema.solver_settings.properties
                                      .timeout.title,
                                  hint: _vm.sseSchema.solver_settings.properties
                                    .timeout.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "timeout",
                                      "messages",
                                    ]
                                  ),
                                  suffix: "seconds",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.solver_settings
                                      .timeout,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR
                                        .solver_settings,
                                      "timeout",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.solver_settings.timeout",
                                },
                              }),
                              _c("v-select", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: "Direction",
                                  hint: _vm.sseSchema.solver_settings.properties
                                    .direction.tooltip,
                                  items:
                                    _vm.sseSchema.solver_settings.properties
                                      .direction.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.solver_settings
                                      .direction,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR
                                        .solver_settings,
                                      "direction",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.solver_settings.direction",
                                },
                              }),
                              _c("InputToggleParam", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "sequencing",
                                      "messages",
                                    ]
                                  ),
                                  label: "Sequencing",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _c("InputPrice", {
                                            attrs: {
                                              num_years: _vm.num_years,
                                              reserves: _vm.input.reserves,
                                              sequencing: {
                                                active: !props.disabled,
                                                allowedSources: [
                                                  "Market",
                                                  "Custom",
                                                ],
                                                allowedSchedules: ["RT"],
                                              },
                                              "multi-year": "",
                                              "node-list": "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: props.param,
                                              callback: function ($$v) {
                                                _vm.$set(props, "param", $$v)
                                              },
                                              expression: "props.param",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3063996787
                                ),
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.sequencing,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "sequencing",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.sequencing",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.sseSchema.save_time_series_outputs
                                      .title,
                                  hint: _vm.sseSchema.save_time_series_outputs
                                    .tooltip,
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR
                                      .save_time_series_outputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "save_time_series_outputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.save_time_series_outputs",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "STACKED_SERVICES_EMULATOR",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings
                                      .STACKED_SERVICES_EMULATOR.saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings
                                        .STACKED_SERVICES_EMULATOR,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.STACKED_SERVICES_EMULATOR.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.ELCC.active
            ? _c(
                "v-tab-item",
                { key: "ELCC" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Methodology",
                                  items: _vm.elccSchema.methodology.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.ELCC.methodology,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "methodology",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.methodology",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.elccSchema.threshold_active.title,
                                  hint: _vm.elccSchema.threshold_active.tooltip,
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ELCC.threshold_active,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "threshold_active",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.threshold_active",
                                },
                              }),
                              _c("InputTextField", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: _vm.elccSchema.target_lole.title,
                                  hint: _vm.elccSchema.target_lole.tooltip,
                                  type: "number",
                                  suffix: _vm.elccSchema.target_lole.unit,
                                  min: _vm.elccSchema.target_lole.minimum,
                                  max: _vm.elccSchema.target_lole.maximum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.ELCC.target_lole,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "target_lole",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.target_lole",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: _vm.elccSchema.tolerance_lole.title,
                                  suffix: _vm.elccSchema.tolerance_lole.unit,
                                  hint: _vm.elccSchema.tolerance_lole.tooltip,
                                  min: _vm.elccSchema.tolerance_lole.minimum,
                                  max: _vm.elccSchema.tolerance_lole.maximum,
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ELCC.tolerance_lole,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "tolerance_lole",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.tolerance_lole",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: _vm.elccSchema.load_step.title,
                                  suffix: _vm.elccSchema.load_step.unit,
                                  hint: _vm.elccSchema.load_step.tooltip,
                                  min: _vm.elccSchema.load_step.minimum,
                                  max: _vm.elccSchema.load_step.maximum,
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.ELCC.load_step,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "load_step",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "computedSettings.ELCC.load_step",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: _vm.elccSchema.load_ratio.title,
                                  suffix: _vm.elccSchema.load_ratio.unit,
                                  hint: _vm.elccSchema.load_ratio.tooltip,
                                  min: _vm.elccSchema.load_ratio.minimum,
                                  max: _vm.elccSchema.load_ratio.maximum,
                                  type: _vm.elccSchema.load_ratio.type,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.ELCC.load_ratio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "load_ratio",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.load_ratio",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label: _vm.elccSchema.save_pc_outputs.title,
                                  hint: _vm.elccSchema.save_pc_outputs.tooltip,
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.ELCC.save_pc_outputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "save_pc_outputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.save_pc_outputs",
                                },
                              }),
                              _vm.settings.ELCC.methodology !==
                              "Net-Load relative to Load"
                                ? _c("InputTextField", {
                                    attrs: {
                                      label: _vm.elccSchema.peaker_step.title,
                                      suffix: _vm.elccSchema.peaker_step.unit,
                                      hint: _vm.elccSchema.peaker_step.tooltip,
                                      min: _vm.elccSchema.peaker_step.minimum,
                                      max: _vm.elccSchema.peaker_step.maximum,
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.ELCC.peaker_step,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings.ELCC,
                                          "peaker_step",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedSettings.ELCC.peaker_step",
                                    },
                                  })
                                : _vm._e(),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "ELCC",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.ELCC.saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.ELCC,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.ELCC.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.POWER_FLOW.active
            ? _c(
                "v-tab-item",
                { key: "Power Flow" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("InputDateTime", {
                                        attrs: {
                                          label: "Start Date",
                                          timezone: "UTC",
                                          minDate:
                                            _vm.systemDateConstraints.min,
                                          maxDate:
                                            _vm.systemDateConstraints.max,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.computedSettings.POWER_FLOW
                                              .start_datetime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings.POWER_FLOW,
                                              "start_datetime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "computedSettings.POWER_FLOW.start_datetime",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("InputDateTime", {
                                        attrs: {
                                          label: "End Date",
                                          timezone: "UTC",
                                          maxDate:
                                            _vm.systemDateConstraints.max,
                                          minDate:
                                            _vm.computedSettings.POWER_FLOW
                                              .start_datetime,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.computedSettings.POWER_FLOW
                                              .end_datetime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings.POWER_FLOW,
                                              "end_datetime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "computedSettings.POWER_FLOW.end_datetime",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "4" } },
                                    [
                                      _c("InputTextField", {
                                        attrs: {
                                          label:
                                            _vm.schema.POWER_FLOW.properties
                                              .time_interval.title,
                                          suffix:
                                            _vm.schema.POWER_FLOW.properties
                                              .time_interval.unit,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.computedSettings.POWER_FLOW
                                              .time_interval,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.computedSettings.POWER_FLOW,
                                              "time_interval",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "computedSettings.POWER_FLOW.time_interval",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-switch", {
                                attrs: { label: "Run Contingency Analysis" },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .run_contingency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "run_contingency",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.run_contingency",
                                },
                              }),
                              _vm.computedSettings.POWER_FLOW.run_contingency
                                ? _c("v-select", {
                                    attrs: {
                                      items: _vm.contingencyTimeOptions,
                                      label: "Time for contingency run",
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.POWER_FLOW
                                          .contingency_time,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings.POWER_FLOW,
                                          "contingency_time",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.POWER_FLOW.contingency_time",
                                    },
                                  })
                                : _vm._e(),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties.source
                                      .title,
                                  items:
                                    _vm.schema.POWER_FLOW.properties.source
                                      .enum,
                                  "item-text": "text",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: _vm.computedSettings.POWER_FLOW.source,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "source",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.source",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties.algorithm
                                      .title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .algorithm.tooltip,
                                  items: _vm.powerFlowAlgorithmItems,
                                  "item-text": "text",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW.algorithm,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "algorithm",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.algorithm",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .calculate_voltage_angles.title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .calculate_voltage_angles.tooltip,
                                  items:
                                    _vm.schema.POWER_FLOW.properties
                                      .calculate_voltage_angles.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .calculate_voltage_angles,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "calculate_voltage_angles",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.calculate_voltage_angles",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .initialization.title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .initialization.tooltip,
                                  items:
                                    _vm.schema.POWER_FLOW.properties
                                      .initialization.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .initialization,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "initialization",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.initialization",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .max_iteration.title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .max_iteration.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .max_iteration,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "max_iteration",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.max_iteration",
                                },
                              }),
                              _c("v-slider", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Tolerance: 1e" +
                                    _vm.computedSettings.POWER_FLOW.tolerance,
                                  max: "-1",
                                  min: "-38",
                                  "always-dirty": "",
                                  "thumb-label": "always",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW.tolerance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "tolerance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.tolerance",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties.trafo_model
                                      .title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .trafo_model.tooltip,
                                  items: _vm.powerFlowTransformerModelItems,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW.trafo_model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "trafo_model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.trafo_model",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .trafo_loading.title,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .trafo_loading.tooltip,
                                  items:
                                    _vm.schema.POWER_FLOW.properties
                                      .trafo_loading.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .trafo_loading,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "trafo_loading",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.trafo_loading",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .check_connectivity.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .check_connectivity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "check_connectivity",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.check_connectivity",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .voltage_depend_loads.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .voltage_depend_loads,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "voltage_depend_loads",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.voltage_depend_loads",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .system_frequency.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .system_frequency.unit,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .system_frequency.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .system_frequency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "system_frequency",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.system_frequency",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .reference_apparent_power.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .reference_apparent_power.unit,
                                  hint: _vm.schema.POWER_FLOW.properties
                                    .reference_apparent_power.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .reference_apparent_power,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "reference_apparent_power",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.reference_apparent_power",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .node_upper_threshold_voltage.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .node_upper_threshold_voltage.unit,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .node_upper_threshold_voltage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "node_upper_threshold_voltage",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.node_upper_threshold_voltage",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .node_lower_threshold_voltage.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .node_lower_threshold_voltage.unit,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .node_lower_threshold_voltage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "node_lower_threshold_voltage",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.node_lower_threshold_voltage",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .trafo_percent_rating.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .trafo_percent_rating.unit,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .trafo_percent_rating,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "trafo_percent_rating",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.trafo_percent_rating",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.POWER_FLOW.properties
                                      .line_percent_rating.title,
                                  suffix:
                                    _vm.schema.POWER_FLOW.properties
                                      .line_percent_rating.unit,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .line_percent_rating,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "line_percent_rating",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.line_percent_rating",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: "Generator Power Factor Threshold",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW
                                      .gen_power_factor_threshold,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "gen_power_factor_threshold",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.gen_power_factor_threshold",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "POWER_FLOW",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.POWER_FLOW.saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.POWER_FLOW,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.POWER_FLOW.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.SHORT_CIRCUIT.active
            ? _c(
                "v-tab-item",
                { key: "Short Circuit" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "pa-2 ma-2", attrs: { width: "700" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .current_calculation.title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .current_calculation.tooltip,
                                  items:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .current_calculation.enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .current_calculation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "current_calculation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.current_calculation",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  suffix:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .low_voltage_grid_tolerance.unit,
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .low_voltage_grid_tolerance.title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .low_voltage_grid_tolerance.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .low_voltage_grid_tolerance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "low_voltage_grid_tolerance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.low_voltage_grid_tolerance",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  disabled: _vm.disableTopology,
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties.topology
                                      .title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .topology.tooltip,
                                  items:
                                    _vm.schema.SHORT_CIRCUIT.properties.topology
                                      .enum,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT.topology,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "topology",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.topology",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .aperiodic_SC_current.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .aperiodic_SC_current,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "aperiodic_SC_current",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.aperiodic_SC_current",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .equivalent_thermical_SC_current.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .equivalent_thermical_SC_current,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "equivalent_thermical_SC_current",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.equivalent_thermical_SC_current",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  disabled: _vm.disableFailureClearingTime,
                                  suffix:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .failure_clearing_time.unit,
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .failure_clearing_time.title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .failure_clearing_time.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .failure_clearing_time,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "failure_clearing_time",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.failure_clearing_time",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  suffix:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .fault_resistance.unit,
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .fault_resistance.title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .fault_resistance.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .fault_resistance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "fault_resistance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.fault_resistance",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  suffix:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .fault_reactance.unit,
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .fault_reactance.title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties
                                    .fault_reactance.tooltip,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .fault_reactance,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "fault_reactance",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.fault_reactance",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .branch_results.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .branch_results,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "branch_results",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.branch_results",
                                },
                              }),
                              _c("v-switch", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties
                                      .return_all_currents.title,
                                  disabled: _vm.disableReturnAllCurrents,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .return_all_currents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "return_all_currents",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.return_all_currents",
                                },
                              }),
                              _c("v-select", {
                                attrs: {
                                  label:
                                    _vm.schema.SHORT_CIRCUIT.properties.bus
                                      .title,
                                  hint: _vm.schema.SHORT_CIRCUIT.properties.bus
                                    .tooltip,
                                  items: _vm.nodeIndex,
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3247118524
                                ),
                                model: {
                                  value: _vm.computedSettings.SHORT_CIRCUIT.bus,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "bus",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.bus",
                                },
                              }),
                              _c("v-switch", {
                                class: "my-" + _vm.inputMargin,
                                attrs: {
                                  label:
                                    "Keep previous outputs when case is saved",
                                  "error-messages": _vm.$utils.getIfExists(
                                    _vm.errors,
                                    [
                                      "settings",
                                      "SHORT_CIRCUIT",
                                      "saveOutputs",
                                      "messages",
                                    ]
                                  ),
                                  hint: "WARNING: Enabling this can cause discrepancies between the stored input and the resulting outputs",
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    _vm.computedSettings.SHORT_CIRCUIT
                                      .saveOutputs,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.computedSettings.SHORT_CIRCUIT,
                                      "saveOutputs",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "computedSettings.SHORT_CIRCUIT.saveOutputs",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.TRANSIENT_STABILITY.active
            ? _c(
                "v-tab-item",
                { key: "Transient Stability" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "pa-2 ma-2", attrs: { width: "700" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("InputDateTime", {
                                    attrs: {
                                      label: "Start Date",
                                      timezone: "UTC",
                                      minDate: _vm.systemDateConstraints.min,
                                      maxDate: _vm.systemDateConstraints.max,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .start_datetime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .TRANSIENT_STABILITY,
                                          "start_datetime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.TRANSIENT_STABILITY.start_datetime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("InputDateTime", {
                                    attrs: {
                                      label: "End Date",
                                      timezone: "UTC",
                                      maxDate: _vm.systemDateConstraints.max,
                                      minDate:
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .start_datetime,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .end_datetime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .TRANSIENT_STABILITY,
                                          "end_datetime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.TRANSIENT_STABILITY.end_datetime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { sm: "4" } },
                                [
                                  _c("InputTextField", {
                                    attrs: {
                                      label: "Simulate every",
                                      suffix: "min",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .simulate_every,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings
                                            .TRANSIENT_STABILITY,
                                          "simulate_every",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "computedSettings.TRANSIENT_STABILITY.simulate_every",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("p", [_vm._v(_vm._s(_vm.transientTimeParams))]),
                          _c("v-select", {
                            attrs: {
                              label: "Simulation source",
                              items: _vm.tStabilitySources,
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .simulation_source,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY,
                                  "simulation_source",
                                  $$v
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.simulation_source",
                            },
                          }),
                          _vm.computedSettings.TRANSIENT_STABILITY
                            .simulation_source === "CASE_TABLE"
                            ? [
                                _c("InputProfile", {
                                  staticClass: "mb-4",
                                  attrs: {
                                    "profile-type": "SIMULATION_TABLE",
                                    label: "Simulations table",
                                    hint: "One row per simulation",
                                    "object-value": "",
                                    "use-headers": [
                                      "inertia",
                                      "max_generator_generation",
                                      "machine_generation",
                                      "max_power_generation",
                                      "min_power_generation",
                                      "generators_reg_up",
                                      "generators_reg_down",
                                      "droop",
                                      "ramp_capability",
                                      "max_battery_cap",
                                      "battery_pow_nom",
                                      "battery_reg_up",
                                      "battery_reg_down",
                                    ],
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .simulation_table,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings
                                          .TRANSIENT_STABILITY,
                                        "simulation_table",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.simulation_table",
                                  },
                                }),
                                _c("InputYearly", {
                                  attrs: {
                                    label: "Base Power",
                                    suffix: "MVA",
                                    type: "number",
                                    num_years: _vm.num_years,
                                    fill: "",
                                    "fill-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .base_power,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings
                                          .TRANSIENT_STABILITY,
                                        "base_power",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.base_power",
                                  },
                                }),
                              ]
                            : [
                                _c("p", { staticClass: "text-caption" }, [
                                  _vm._v(
                                    " Use SSE outputs for transient stability analysis. Remember to set inertia and droop parameters. Only the first project will be used. "
                                  ),
                                ]),
                              ],
                          _c("v-select", {
                            attrs: {
                              label:
                                "Include individual simulations in the output",
                              items: _vm.tStabilityIncludeSimulations,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .include_simulations,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY,
                                  "include_simulations",
                                  $$v
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.include_simulations",
                            },
                          }),
                          _c("InputTextField", {
                            attrs: {
                              hint: "Time interval for transient simulation calculations",
                              label: "Time Step",
                              suffix: "s",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .time_step,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY,
                                  "time_step",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.time_step",
                            },
                          }),
                          _c("v-divider"),
                          _c("InputTextField", {
                            attrs: {
                              label: "Base Frequency",
                              suffix: "Hz",
                              hint: "System Frequency",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .base_frequency,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY,
                                  "base_frequency",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.base_frequency",
                            },
                          }),
                          _c("InputTextField", {
                            attrs: {
                              label: "Equivalent Damping Factor",
                              suffix: "pu",
                              hint: "Measure of system oscillation reduction",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .equivalent_damping_factor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY,
                                  "equivalent_damping_factor",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.equivalent_damping_factor",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Generator Response",
                              hint: "Use generators for frequency response",
                              "persistent-hint": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .generator_response.active,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY
                                    .generator_response,
                                  "active",
                                  $$v
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.generator_response.active",
                            },
                          }),
                          _vm.computedSettings.TRANSIENT_STABILITY
                            .generator_response.active
                            ? [
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Delay",
                                    suffix: "s",
                                    hint: "Lag in transient stability response",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .generator_response.delay,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .generator_response,
                                        "delay",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.generator_response.delay",
                                  },
                                }),
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Dead Band",
                                    suffix: "mHz",
                                    hint: "Range where generator ignores small signal changes",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .generator_response.deadband,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .generator_response,
                                        "deadband",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.generator_response.deadband",
                                  },
                                }),
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Lead Time Constant",
                                    hint: "Speed of initial generator control response",
                                    suffix: "s",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .generator_response.lead_time,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .generator_response,
                                        "lead_time",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.generator_response.lead_time",
                                  },
                                }),
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Lag Time Constant",
                                    suffix: "s",
                                    hint: "Time to reach steady state after response has started",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .generator_response.lag_time,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .generator_response,
                                        "lag_time",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.generator_response.lag_time",
                                  },
                                }),
                                _c("v-divider"),
                              ]
                            : _vm._e(),
                          _c("v-switch", {
                            attrs: {
                              label: "BESS Response",
                              hint: "Use BESS for frequency response",
                              "persistent-hint": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .bess_response.active,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY
                                    .bess_response,
                                  "active",
                                  $$v
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.bess_response.active",
                            },
                          }),
                          _vm.computedSettings.TRANSIENT_STABILITY.bess_response
                            .active
                            ? [
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Delay",
                                    suffix: "s",
                                    hint: "Delay for BESS response",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .bess_response.delay,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .bess_response,
                                        "delay",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.bess_response.delay",
                                  },
                                }),
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Dead Band",
                                    suffix: "mHz",
                                    hint: "Deadband for BESS response",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .bess_response.deadband,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .bess_response,
                                        "deadband",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.bess_response.deadband",
                                  },
                                }),
                                _c("InputProfile", {
                                  attrs: {
                                    "profile-type": "FREQUENCY_RESPONSE",
                                    hint: "Response in percentage of storage power capacity",
                                    label: "Frequency Response Curve",
                                    "object-value": "",
                                    "use-headers": ["frequency", "response"],
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .bess_response.freq_curve,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .bess_response,
                                        "freq_curve",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.bess_response.freq_curve",
                                  },
                                }),
                                _c("v-divider"),
                              ]
                            : _vm._e(),
                          _c("v-switch", {
                            attrs: {
                              label: "UFLS Response",
                              hint: "Load shedding under frequency",
                              "persistent-hint": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value:
                                _vm.computedSettings.TRANSIENT_STABILITY
                                  .ufls_response.active,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedSettings.TRANSIENT_STABILITY
                                    .ufls_response,
                                  "active",
                                  $$v
                                )
                              },
                              expression:
                                "computedSettings.TRANSIENT_STABILITY.ufls_response.active",
                            },
                          }),
                          _vm.computedSettings.TRANSIENT_STABILITY.ufls_response
                            .active
                            ? [
                                _c("InputTextField", {
                                  attrs: {
                                    label: "Delay",
                                    suffix: "s",
                                    hint: "Delay for UFLS",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .ufls_response.delay,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .ufls_response,
                                        "delay",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.ufls_response.delay",
                                  },
                                }),
                                _c("InputProfile", {
                                  attrs: {
                                    "profile-type": "FREQUENCY_RESPONSE",
                                    hint: "Response in MW together with the frequency at which it its UFLS level gets activated",
                                    label: "Frequency Response Curve",
                                    "object-value": "",
                                    "use-headers": ["frequency", "response"],
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.computedSettings.TRANSIENT_STABILITY
                                        .ufls_response.freq_curve,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.computedSettings.TRANSIENT_STABILITY
                                          .ufls_response,
                                        "freq_curve",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "computedSettings.TRANSIENT_STABILITY.ufls_response.freq_curve",
                                  },
                                }),
                                _c("v-divider"),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.computedSettings.LOAD_FORECAST.active
            ? _c(
                "v-tab-item",
                { key: "Load Forecast" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2 ma-2",
                          attrs: { outlined: "", width: "700" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [_vm._v("Timeline Configuration")]
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "my-4",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { sm: "4" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Present Year",
                                              hint: "First year to be forecasted",
                                              "persistent-hint": "",
                                              type: "number",
                                              dense: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.computedSettings
                                                  .LOAD_FORECAST.year_present,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.computedSettings
                                                    .LOAD_FORECAST,
                                                  "year_present",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "computedSettings.LOAD_FORECAST.year_present",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.computedSettings.LOAD_FORECAST
                                        .year_present
                                        ? _c("v-col", { attrs: { sm: "4" } }, [
                                            _c(
                                              "p",
                                              { staticClass: "text-caption" },
                                              [
                                                _vm._v(
                                                  "Historic Data Points: " +
                                                    _vm._s(
                                                      _vm.historicDataPoints
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "text-caption" },
                                              [
                                                _vm._v(
                                                  " From " +
                                                    _vm._s(
                                                      _vm.settings.year_start
                                                    ) +
                                                    " to " +
                                                    _vm._s(
                                                      _vm.settings.LOAD_FORECAST
                                                        .year_present - 1
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.computedSettings.LOAD_FORECAST
                                        .year_present
                                        ? _c("v-col", { attrs: { sm: "4" } }, [
                                            _c(
                                              "p",
                                              { staticClass: "text-caption" },
                                              [
                                                _vm._v(
                                                  "Forecast Data Points: " +
                                                    _vm._s(
                                                      _vm.forecastDataPoints
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "text-caption" },
                                              [
                                                _vm._v(
                                                  " From " +
                                                    _vm._s(
                                                      _vm.settings.LOAD_FORECAST
                                                        .year_present
                                                    ) +
                                                    " to " +
                                                    _vm._s(
                                                      _vm.settings.year_end
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      label: "Granularity",
                                      items: ["yearly", "monthly"],
                                      hint: "Temporal granularity for the forecast",
                                      "persistent-hint": "",
                                      dense: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.LOAD_FORECAST
                                          .granularity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings.LOAD_FORECAST,
                                          "granularity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.LOAD_FORECAST.granularity",
                                    },
                                  }),
                                  _c("v-divider", { staticClass: "mt-4" }),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c("InputProfile", {
                                    staticClass: "mb-4",
                                    attrs: {
                                      "profile-type": "LF_HISTORIC_DATA",
                                      label: "Historic data",
                                      hint:
                                        "gdp, population, electric vehicles, energy intensity, total load. " +
                                        _vm.historicDataPoints +
                                        " values expected",
                                      "object-value": "",
                                      "use-headers": [
                                        "gdp",
                                        "population",
                                        "electric vehicles",
                                        "energy intensity",
                                        "total load",
                                      ],
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.LOAD_FORECAST
                                          .historic_data,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings.LOAD_FORECAST,
                                          "historic_data",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.LOAD_FORECAST.historic_data",
                                    },
                                  }),
                                  _c("InputProfile", {
                                    staticClass: "mb-4",
                                    attrs: {
                                      "profile-type": "LF_FUTURE_DATA",
                                      label: "Future data",
                                      hint:
                                        "gdp, population, electric vehicles, energy intensity. " +
                                        _vm.forecastDataPoints +
                                        " values expected",
                                      "object-value": "",
                                      "use-headers": [
                                        "gdp",
                                        "population",
                                        "electric vehicles",
                                        "energy intensity",
                                      ],
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.computedSettings.LOAD_FORECAST
                                          .forecast_data,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.computedSettings.LOAD_FORECAST,
                                          "forecast_data",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "computedSettings.LOAD_FORECAST.forecast_data",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                { staticClass: "mb-6", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium mb-1",
                                    },
                                    [
                                      _vm._v(
                                        " Peak Load Calculation Parameters "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "text-caption" },
                                    [
                                      _vm._v(" Formula: "),
                                      _c(
                                        "math",
                                        [
                                          _c(
                                            "mrow",
                                            [
                                              _c("mi", [
                                                _vm._v(
                                                  "Annual Peak Demand (MW)"
                                                ),
                                              ]),
                                              _c("mo", [_vm._v("=")]),
                                              _c("mi", [_vm._v("α")]),
                                              _c("mo", [_vm._v("⋅")]),
                                              _c("mi", [
                                                _vm._v(
                                                  "Annual Energy Demand (GWh)"
                                                ),
                                              ]),
                                              _c("mo", [_vm._v("+")]),
                                              _c("mi", [_vm._v("β")]),
                                              _c("mo", [_vm._v("⋅")]),
                                              _c(
                                                "msqrt",
                                                [
                                                  _c("mi", [
                                                    _vm._v(
                                                      "Annual Energy Demand (GWh)"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { sm: "6" } },
                                        [
                                          _c("InputTextField", {
                                            attrs: {
                                              label: "Alpha",
                                              hint: "Linear coefficient for peak load calculation",
                                              type: "number",
                                              step: "0.01",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.computedSettings
                                                  .LOAD_FORECAST.alpha,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.computedSettings
                                                    .LOAD_FORECAST,
                                                  "alpha",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "computedSettings.LOAD_FORECAST.alpha",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { sm: "6" } },
                                        [
                                          _c("InputTextField", {
                                            attrs: {
                                              label: "Beta",
                                              hint: "Square root coefficient for peak load calculation",
                                              type: "number",
                                              step: "0.01",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.computedSettings
                                                  .LOAD_FORECAST.beta,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.computedSettings
                                                    .LOAD_FORECAST,
                                                  "beta",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "computedSettings.LOAD_FORECAST.beta",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }